import React from "react";
function BreakLine({ ...other }) {
    return (
        <div className="break-line" {...other}></div>
    );
}


export default BreakLine;